<script>
// Design system "Tooltip", Plain · Top · Dark: one short line above its trigger, which must be position: relative.
export default {
    props: {
        text: String,
        // start/end pin the bubble to the trigger's left/right edge where centring would leave a clipped container
        align: {
            default: 'center',
            type: String,
        },
        // px the bubble may grow to before its line wraps; the design's 240 unless the container is narrower
        maxWidth: {
            default: 240,
            type: Number,
        },
        // top (the design's) or bottom, where the trigger has too little room above it
        placement: {
            default: 'top',
            type: String,
        },
    },
}
</script>

<template>
    <div
        class="
            tw:absolute
            tw:z-20
            tw:flex
            tw:pointer-events-none
            tw:drop-shadow-[0_8px_12px_rgba(0,0,0,0.1)]
        "
        role="tooltip"
        v-bind:class="{
            'tw:bottom-full tw:mb-1 tw:flex-col': placement === 'top',
            'tw:top-full tw:mt-1 tw:flex-col-reverse': placement === 'bottom',
            'tw:left-1/2 tw:-translate-x-1/2 tw:items-center': align === 'center',
            'tw:left-0 tw:items-start': align === 'start',
            'tw:right-0 tw:items-end': align === 'end',
        }"
    >
        <p
            class="
                tw:m-0
                tw:px-3
                tw:py-2
                tw:w-max
                tw:text-sm
                tw:font-normal
                tw:leading-[1.45]
                tw:text-left
                tw:text-white
                tw:bg-[#0d3b66]
                tw:rounded-lg
            "
            v-bind:style="{ 'max-width': maxWidth + 'px' }"
            v-text="text"
        ></p>
        <svg
            class="tw:block tw:w-3.5 tw:h-[7px]"
            aria-hidden="true"
            viewBox="0 0 14 7"
            v-bind:class="{ 'tw:mx-3': align !== 'center', 'tw:rotate-180': placement === 'bottom' }"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0H14L7 7L0 0Z" fill="#0D3B66"/>
        </svg>
    </div>
</template>
